module.exports = __webpack_public_path__ + "img/61.5a54a89c.jpeg";